module.exports = __webpack_public_path__ + "img/booth-graphic.c2accec2.png";